var plugin_default = {
  "alignLeft": "dKsBO",
  "textWrapNowrap": "YRZEF",
  "alignRight": "NLLHf",
  "alignCenter": "B43N7",
  "sizeFullWidth": "aA0eA",
  "renderedInTable": "OSa73",
  "sizeOriginal": "_3FAzS",
  "sizeContent": "uY2tw",
  "sizeSmall": "hN6P9",
  "sizeSmallCenter": "jRX3I",
  "flex": "al8KK",
  "atomic": "kWv2d",
  "embed": "xgIsX",
  "horizontalScrollbar": "_9KhqS",
  "pluginContainerMobile": "JBmDR"
};
export {
  plugin_default as default
};
//# sourceMappingURL=plugin-scss.js.map
